import { FaCheck, FaExclamationTriangle } from 'react-icons/fa';

export const toastCheckIcon = () => <FaCheck />;
export const toastWarningIcon = () => <FaExclamationTriangle />;
